/**
 * Subtle, professional "back to homepage" link for auth pages.
 *
 * Per the P0 UX brief: the login / signup / forgot / reset pages
 * must never feel like a dead end — every page surfaces a clear
 * route back to the public landing page. Styling intentionally
 * stays understated (not a CTA, not alarming) so it complements
 * the page's primary action.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackToHomepageLink({
  className = "",
  testId = "back-to-homepage",
  label = "Back to Homepage",
}) {
  return (
    <Link
      to="/"
      data-testid={testId}
      className={
        "inline-flex items-center gap-2 text-xs tracking-wider uppercase " +
        "text-slate-400 hover:text-amber-400 transition-colors " +
        "font-manrope " +
        className
      }
    >
      <ArrowLeft className="w-3.5 h-3.5" />
      <span>{label}</span>
    </Link>
  );
}
